<!--用户页 管理员数据表-->
<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="adminData"
            hide-default-footer
            class="elevation-1"
            disable-sort
            :dark="theme.tableDark"
        >
            <template v-slot:item.role="{ item }">
                {{ permissions(item.role) }}
                <el-dropdown @command="modifyPermis" trigger="click">
                    <span class="el-dropdown-link">
                        <el-link
                            type="primary"
                            icon="el-icon-edit"
                            class="ml-3"
                            @click="disabled('权限', item)"
                        >
                            修改权限
                        </el-link>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="(item, index) in permissionsText"
                            :key="index"
                            :command="item.command"
                            :disabled="item.disabled"
                        >
                            {{ permissions(item.command) }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <template v-slot:item.status="{ item }">
                {{ state(item.status) }}
                <el-dropdown @command="modifyState" trigger="click">
                    <span class="el-dropdown-link">
                        <el-link
                            type="primary"
                            icon="el-icon-edit"
                            class="ml-3"
                            @click="disabled('状态', item)"
                        >
                            修改状态
                        </el-link>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="(item, index) in stateText"
                            :key="index"
                            :command="item.command"
                            :disabled="item.disabled"
                        >
                            {{ state(item.command) }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
            <template v-slot:item.editor="{ item }">
                <el-popconfirm
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon="el-icon-info"
                    icon-color="red"
                    title="确定要删除此用户吗"
                    @confirm="confirm(item.id)"
                >
                    <el-button type="text" slot="reference">
                        <v-icon class="ml-3" color="red">
                            mdi-delete
                        </v-icon>
                    </el-button>
                </el-popconfirm>
            </template>
            <template v-slot:item.last_login="{ item }">
                {{ new Date(item.last_login * 1000).toLocaleString() }}
            </template>
        </v-data-table>
    </div>
</template>

<script>
import util from "@/util";
import { mapState } from "vuex";
export default {
    data() {
        return {
            headers: [
                { text: "编号", value: "id" },
                { text: "用户名", value: "name" },
                { text: "权限", value: "role" },
                { text: "状态", value: "status" },
                { text: "上一次登录时间", value: "last_login" },
                { text: "", value: "editor" },
            ],
            permissionsText: [
                {
                    command: "0",
                    disabled: false,
                },
                {
                    command: "1",
                    disabled: false,
                },
            ],
            stateText: [
                {
                    command: "0",
                    disabled: false,
                },
                {
                    command: "1",
                    disabled: false,
                },
                {
                    command: "2",
                    disabled: false,
                },
                {
                    command: "3",
                    disabled: false,
                },
            ],
            clickAdmin: null,
        };
    },
    props: {
        adminData: Array,
    },
    computed: {
        ...mapState(["theme"]),
    },
    methods: {
        /*修改权限*/
        modifyPermis(e) {
            this.modify("权限", e);
        },
        /*修改状态*/
        modifyState(e) {
            this.modify("状态", e);
        },
        modify(name, num) {
            if (this.clickAdmin === null) {
                return;
            }
            let postData = {
                role: name === "权限" ? Number(num) : Number(this.clickAdmin.role),
                id: Number(this.clickAdmin.id),
                status: name === "状态" ? Number(num) : Number(this.clickAdmin.status),
            };
            util.post("/api", postData)
                .then(response => {
                    let data = response.data;
                    if (data.result === "OK") {
                        util.ShowTip("修改成功", 1);
                        this.$emit("modifyPermis");
                    }
                })
                .catch(err => {
                    console.log(err);
                    util.ShowTip("修改失败", 2);
                });
        },
        /*删除管理员*/
        confirm(id) {
            console.log(id);
        },
        /*判断权限*/
        permissions(e) {
            if (e == 0) return "超级管理员";
            else return "管理员";
        },
        /*判断状态*/
        state(e) {
            if (e == 0) return "正常";
            else if (e == 1) return "待审核";
            else if (e == 2) return "驳回";
            else return "冻结";
        },
        /*设置是否禁用*/
        disabled(name, item) {
            this.clickAdmin = item;
            if (name === "权限") {
                for (let i = 0; i < this.permissionsText.length; i++) {
                    this.permissionsText[i].disabled = false;
                }
                let index = Number(item.role);
                this.permissionsText[index].disabled = true;
            }
            if (name === "状态") {
                for (let i = 0; i < this.stateText.length; i++) {
                    this.stateText[i].disabled = false;
                }
                let index = Number(item.status);
                this.stateText[index].disabled = true;
            }
        },
    },
};
</script>
